Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-offline-order-item-list'), model = null;

    if ($wrappers.length < 1) return;

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var wrapper = $wrapper.get(0);
        var orderId = $wrapper.data('orderId');
        var initLoading = false;

        var $loadingIndicator = $('.details-loading-indicator', $wrapper);
        var $loadingError = $('.details-loading-error', $wrapper);

        wrapper.loading = function loading(loading, error) {
            if (loading && initLoading)
                return false;

            initLoading = loading;

            if (loading) {
                $loadingIndicator.show();
                $loadingError.hide();
            } else {
                $loadingIndicator.hide();
                error && $loadingError.show();
            }

            return true;
        };

        wrapper.showLoader = function (loader) {
            var $cont = $wrapper.closest('.x-offline-order');

            if (loader === true) {
                $cont.addClass('x-loading');
            } else {
                $cont.removeClass('x-loading');
            }
        };

        wrapper.init = function () {
            if (!wrapper.loading(true) || $wrapper.hasClass('already-binded'))
                return;

            wrapper.showLoader(true);
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.OfflineOrdersHistory.Messages.GetOrderItems(orderId));
        };

        wrapper.update = function () {
            var partial = $wrapper.data('partial');
            var html = Vendd.Handlebars.parse(partial, model);

            wrapper.bind(html);
            wrapper.loading(false);
            wrapper.showLoader(false);

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.OfflineOrdersHistory.Messages.OrderItemsRendered((model.Items || []).length));
        };

        wrapper.bind = function bind(html) {
            $wrapper.html(html);
            $wrapper.addClass('already-binded');
        };

        $('.retry-details-loading-button', $wrapper).on('click', function () {
            wrapper.update();
        });
    });

    Vendd.MessageBus.subscribe(Vendd.OfflineOrdersHistory.Messages.GetOrderItemsSuccess, 'x-offline-order-item-list', function (envelope) {
        var response = envelope.message.data;

        model = {
            Items: response.data.Items,
            Translators: response.data.Translators
        };

        var wrapper = envelope.sender;
        if (wrapper) wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.OfflineOrdersHistory.Messages.GetOrderItemsFailure, 'x-offline-order-item-list', function (envelope) {
        var wrapper = envelope.sender;
        var response = envelope.message.data;

        if (wrapper) {
            console.log('Failed to load offline order details:', response);

            wrapper.loading(false, true);
            wrapper.showLoader(false);
        }
    });
});